<script lang="ts">
export default {
  props: {
    level: Number,
    text: String,
    hasPulse: { type: Boolean, default: false },
  },
  setup(props) {
    const tag = `h${props.level}`

    const fontStyles = new Map()
    fontStyles.set(1, 'text-4xl font-neo-screen-head')
    fontStyles.set(2, 'text-2xl leading-10 font-neo-screen-head')
    fontStyles.set(3, 'text-lg leading-6 font-bold')

    const data: UtilityHeadlineData = {
      class: `font-black ${fontStyles.get(props.level)} ${
        props.hasPulse && useRuntimeConfig().public.client === 'cab'
          ? 'headline-pulse after:content-[url("/assets/svg/dbc-pulse.svg")] after:h-[6px] after:w-[58px] after:block after:m-auto after:leading-0'
          : ''
      }`,
    }

    const children = props.text

    return () => h(tag, data, children)
  },
}
</script>
